import { render, staticRenderFns } from "./SeriesTab.vue?vue&type=template&id=267e0ac6"
import script from "./SeriesTab.vue?vue&type=script&lang=js"
export * from "./SeriesTab.vue?vue&type=script&lang=js"
import style0 from "./SeriesTab.vue?vue&type=style&index=0&id=267e0ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports